var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0385 16.2747C13.1611 16.704 13.5535 17 14 17C14.4465 17 14.8389 16.704 14.9615 16.2747L15.6114 14H17C17.5523 14 18 13.5523 18 13C18 12.4477 17.5523 12 17 12H16.1829L16.4686 11H17C17.5523 11 18 10.5523 18 10C18 9.4478 17.5524 9.00013 17.0002 9C17.0005 8.56464 16.7141 8.16402 16.2747 8.03848C15.7437 7.88675 15.1902 8.19424 15.0385 8.72528L14 12.3599L12.9663 8.74203C12.9573 8.7085 12.9466 8.67551 12.9342 8.64322C12.8828 8.50816 12.8045 8.38985 12.7072 8.29277C12.6102 8.1956 12.4921 8.11731 12.3572 8.0659C12.2446 8.02276 12.1237 7.99968 12 7.99974C11.7326 7.99961 11.4783 8.1076 11.2928 8.29276C11.1956 8.38977 11.1173 8.50795 11.0659 8.64286C11.0534 8.67529 11.0427 8.7084 11.0337 8.74207L9.99999 12.3599L8.96151 8.72528C8.80979 8.19424 8.2563 7.88675 7.72527 8.03848C7.28586 8.16402 6.99951 8.56464 6.99973 9C6.44757 9.00015 6 9.44781 6 10C6 10.5523 6.44772 11 7 11H7.5314L7.81711 12H7C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14H8.38854L9.03846 16.2747C9.16112 16.704 9.55351 17 9.99999 17C10.4465 17 10.8389 16.704 10.9615 16.2747L12 12.6401L13.0385 16.2747Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon_money.7c5c5658ffd4f4c343593eaa9d4c36c0.svg";
export { ForwardRef as ReactComponent };